<template>
  <button v-if="params && !params.loading"
          type="button"
          :class="{enabled: !params.disabled, disabled: params.disabled, secondary: isSecondary && !params.disabled, compact: isCompact}"
          :disabled='params.disabled'>
    <span>{{params.text}}</span>
  </button>
  <button v-else-if="params"
          type="button"
          :class="{enabled: !params.disabled, disabled: params.disabled, secondary: isSecondary && !params.disabled, compact: isCompact}"
          :disabled='params.disabled'>
    <span class="fas fa-lemon"></span>
  </button>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLemon } from "@fortawesome/free-solid-svg-icons";
library.add(faLemon);

export default {
  name: 'CustomButton',
  props: ['params', 'isSecondary', 'isCompact']
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

@keyframes ckw
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)

.fa-lemon
  width 16px
  height 16px
  color THEME_COLOR_PRIMARY !important
  opacity 0.6
  animation-name ckw
  animation-duration 1s
  animation-iteration-count infinite
  transform-origin 50% 50%

  svg
    width 18px !important
    height 18px !important

button
  width 100%
  min-height CTRL_HEIGHT
  height auto
  background-color CTRL_DISABLED_BG
  color THEME_COLOR_PRIMARY_OPPOSITE
  border 1px solid transparent
  border-radius CTRL_RADIUS
  font-weight bold
  padding 8px 16px
  transition background-color CTRL_EASE, border-color CTRL_EASE, box-shadow CTRL_EASE, transform CTRL_EASE

//---- Disabled button -----
.disabled
  background-color CTRL_DISABLED_BG
  color CTRL_DISABLED_TEXT
  border-color transparent
  cursor not-allowed
  box-shadow none

//---- Enabled button (principal) -----
.enabled
  background-color THEME_COLOR_PRIMARY
  cursor pointer

.enabled:hover
  background-color CTRL_PRIMARY_HOVER
  box-shadow 0 6px 14px -6px rgba(THEME_COLOR_PRIMARY, 0.55)

.enabled:active
  background-color CTRL_PRIMARY_ACTIVE
  box-shadow none
  transform translateY(1px)

.enabled:focus-visible
  outline none
  box-shadow 0 0 0 2px white, 0 0 0 4px CTRL_FOCUS

//---- Secondary button (contour discret) -----
.secondary
  border-color rgba(THEME_COLOR_PRIMARY, 0.3)
  background transparent
  color THEME_COLOR_PRIMARY

.secondary:hover
  background-color rgba(THEME_COLOR_PRIMARY, 0.07)
  border-color rgba(THEME_COLOR_PRIMARY, 0.5)
  box-shadow none

.secondary:active
  background-color rgba(THEME_COLOR_PRIMARY, 0.12)

.secondary:focus-visible
  box-shadow 0 0 0 2px white, 0 0 0 4px CTRL_FOCUS

//---- Compact button -----
.compact
  min-height CTRL_HEIGHT_SM
  height auto
  padding 6px 12px
  font-size 12px
  line-height 1.15
  border-radius CTRL_RADIUS_SM
  font-weight 600
  box-shadow none
  white-space normal


  .fa-lemon
    width 16px
    height 16px

    svg
      width 16px !important
      height 16px !important

.compact:hover
  box-shadow none

.compact:focus-visible
  box-shadow 0 0 0 2px white, 0 0 0 4px CTRL_FOCUS

.compact.secondary
  background transparent
  border-color rgba(THEME_COLOR_PRIMARY, 0.3)
  color THEME_COLOR_PRIMARY

.compact.secondary:hover
  background-color rgba(THEME_COLOR_PRIMARY, 0.07)
  border-color rgba(THEME_COLOR_PRIMARY, 0.5)

.compact.disabled
  background CTRL_DISABLED_BG
  border-color transparent
  color CTRL_DISABLED_TEXT
  box-shadow none
</style>